export { default as CoversHalfCard } from "./CoversHalfCard";
export type { ICoversHalfCardProps } from "./types";
